// class FullWidthCellRenderer {
//   eGui

import Vue from 'vue'

//   init(params) {
//     // trick to convert string of html into dom object
//     const eTemp = document.createElement('div')
//     eTemp.innerHTML = this.getTemplate(params)
//     this.eGui = eTemp.firstElementChild
//   }

//   //   getTemplate(params) {
//   //     // the flower row shares the same data as the parent row
//   //     const data = params.node.data

//   //     const template = `<div class="full-width-panel">
//   //                 <div class="full-width-flag">
//   //                     <img border="0" src="https://www.ag-grid.com/example-assets/large-flags/${
//   //   data.code
//   // }.png">
//   //                 </div>
//   //                 <div class="full-width-summary">
//   //                     <span class="full-width-title">${data.name}</span><br/>
//   //                     <label><b>Population:</b> ${
//   //   data.population
//   // }</label><br/>
//   //                     <label><b>Known For:</b> ${data.summary}</label><br/>
//   //                 </div>
//   //                 <div class="full-width-center">${this.latinText()}
//   //                 </div>
//   //             </div>`

//   //     return template
//   //   }
//   getTemplate(params) {
//     let template = ''
//     if (params.data.isHtml) {
//       template = `<div class="ag-full-width-row" v-html="${params.data.html}"></div>`
//     } else {
//       template = `<div class="ag-full-width-row">${params.data.name}</div>`
//     }
//     return template
//   }

//   // latinText() {
//   //   return '<div>Test full Width cellRender</div>'
//   // }

//   getGui() {
//     return this.eGui
//   }

//   refresh(params) {
//     return false
//   }
// }

// export default FullWidthCellRenderer

export default Vue.extend({
  data() {
    return {}
  },
  methods: {},
  template: `
    <div class="ag-full-width-row" >
      <span v-if="!params.data.isHtml">
        {{ params.data.name }}
      </span>
      <div style="width: 100%" v-else v-html="params.data.html"></div>
    </div>
  `
})
